/* eslint-disable no-console */
import {Button} from 'antd';
import React from 'react';

interface AddBtnProps {
  actionProp: any;
  btnPress?: any;
  isSelected?: boolean;
}

const AddBtn: React.FC<AddBtnProps> = ({actionProp, btnPress}) => {
  return (
    <Button
      // className={isSelected ? 'actionBtnSelected' : 'actionBtn'}
      type="primary"
      onClick={btnPress}
    >
      {actionProp}
    </Button>
  );
};

export default AddBtn;
